import { Box } from "@mui/material";
import Typography from "components/common/Typography";
import FilterButtons from "./plans/FilterButtons";

interface Props {
  id?: string;
  getInputDetails?: (args: any) => void;
  searchText?: string;
  inputText?: string;
  isSearchBarVisible?: boolean;
  suggested?: boolean;
  isPlanTypeVisible?: boolean;
}

const SearchAndFilterRow = (props: Props) => {
  const { id, getInputDetails, searchText, inputText, isSearchBarVisible, suggested, isPlanTypeVisible } = props;

  return (
    <>
      <FilterButtons
        value={inputText}
        isSearchBarVisible={!!(id ?? isSearchBarVisible)}
        getInputDetails={getInputDetails}
        functionalAreaId={id}
        isFilterCategoriesVisible={!suggested}
        suggested={suggested}
        isPlanTypeVisible={isPlanTypeVisible}
      />
      {!searchText && inputText && (
        <Box marginLeft={"10px"} marginBottom={"16px"} display="flex" flexDirection={"row"} gap="5px">
          <Typography variant={"body1"}>Showing search results for</Typography>
          <Typography variant={"body1"} showBold>
            "{inputText}"
          </Typography>
        </Box>
      )}
    </>
  );
};

export default SearchAndFilterRow;
